export default defineNuxtRouteMiddleware((to, from) => {
	const localLink = useLocaleLink();
	if (to.path.includes("/free_design_solution.html")) {
		return navigateTo(localLink("/solution-services.html"));
	}
});
